import React from 'react';
import { Link } from 'react-router-dom';

export const DashboardCard = ({ title, icon, quantity, to, isLoading = true }) => {
    return (
        <Link className="text-decoration-none" to={to}>
            <div className="card mb-3">
                <div className="card-body d-flex flex-row justify-content-between px-4 py-3">
                    <div className="d-flex flex-column justify-content-around">
                        {!isLoading && <p className="text-dark fw-bold fs-1 mb-0">{quantity}</p>}
                        {isLoading && (
                            <p className="text-dark fw-bold fs-1 mb-0">
                                <span className="fas fa-sync fa-spin"></span>
                            </p>
                        )}
                        <p className="text-muted fw-normal fs-5 mb-0">{title}</p>
                    </div>
                    <span className={`fal fa-${icon} fa-5x text-primary`} />
                </div>
            </div>
        </Link>
    );
};

// <div className="placeholder-glow col-lg-3 col-xl-4">
//     <span className="placeholder bg-secondary w-100 mt-1 mb-2"></span>
// </div>

// <p className="text-dark fw-bold fs-1 mb-0">
//     <span className="fas fa-sync fa-spin"></span>
// </p>;
